import React from 'react';
import { StyledLabelContainer, StyledLabelText } from './label-box.style';
import { theme } from '../../../style/global-style';
import { ILabelName, IClusterName } from '../../../utils/normalizeLabels';
import { SvgIcon } from '@mui/material';
import CoupleIcon from '../../../../public/static/labels/couple.svg';
import FamilyIcon from '../../../../public/static/labels/family.svg';
import FamilySmallChildIcon from '../../../../public/static/labels/family-small-child.svg';
import SingleIcon from '../../../../public/static/labels/single.svg';
import FriendsIcon from '../../../../public/static/labels/friends.svg';
import { alpha } from '@mui/material/styles';

export interface IUGCLabelProps {
    label: ILabelName;
    type: IClusterName;
}

export interface ILabelBoxProps {
    label: string;
    type: ILabelName;
}

interface ILabelCluster {
    [key: string]: {
        fontColor: string;
        backgroundColor: string;
        icon?: React.ReactElement<React.SVGProps<SVGSVGElement>>;
    };
}

const labelClusterType: ILabelCluster = {
    bestseller: {
        fontColor: theme.shades.white,
        backgroundColor: theme.labels.bestseller,
    },
    highDemand: {
        fontColor: theme.shades.white,
        backgroundColor: theme.labels.highDemand,
    },
    shipRating: {
        fontColor: theme.shades.white,
        backgroundColor: theme.labels.shipRatings,
    },
    atmosphere: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    ageRange: { fontColor: theme.shades.white, backgroundColor: theme.colors.main2 },
    productData: { fontColor: theme.shades.white, backgroundColor: theme.labels.bestseller },
    cabinRating: {
        fontColor: theme.shades.white,
        backgroundColor: theme.labels.cabinRatings,
    },
    gastronomyRating: { fontColor: theme.shades.white, backgroundColor: theme.labels.gastroRating },
    entertainmentRating: {
        fontColor: theme.shades.white,
        backgroundColor: theme.labels.entertainmentRating,
    },
    serviceRating: { fontColor: theme.shades.white, backgroundColor: theme.labels.serviceRating },
    firstCruise: { fontColor: theme.shades.white, backgroundColor: theme.colors.dreamdealMain },
    experienceLabels: {
        fontColor: theme.shades.white,
        backgroundColor: theme.colors.dreamdealMain,
    },

    experiencedCruiseTraveler: {
        fontColor: theme.shades.white,
        backgroundColor: theme.colors.dreamdealMain,
    },
    ageRangeYoung: { fontColor: theme.shades.white, backgroundColor: theme.colors.main2 },
    ageRangeSenior: { fontColor: theme.shades.white, backgroundColor: theme.colors.main2 },
    itineraryRating: { fontColor: theme.shades.white, backgroundColor: theme.labels.routeRatings },
    excursionsRating: { fontColor: theme.shades.white, backgroundColor: theme.labels.routeRatings },
    constellationcouple: {
        icon: <CoupleIcon />,
        fontColor: theme.shades.white,
        backgroundColor: theme.colors.main2,
    },
    constellationfamily: {
        icon: <FamilyIcon />,
        fontColor: theme.shades.white,
        backgroundColor: theme.colors.main2,
    },
    constellationfamilysmallchildren: {
        icon: <FamilySmallChildIcon />,
        fontColor: theme.shades.white,
        backgroundColor: theme.colors.main2,
    },
    constellationsingle: {
        icon: <SingleIcon />,
        fontColor: theme.shades.white,
        backgroundColor: theme.colors.main2,
    },
    constellationfriends: {
        icon: <FriendsIcon />,
        fontColor: theme.shades.white,
        backgroundColor: theme.colors.main2,
    },
    atmospherefamiliar: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    atmosphererelaxed: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    atmospherechaotic: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    atmospherediverse: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    atmosphereelegant: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    atmosphereloud: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    atmosphereboring: { fontColor: theme.shades.white, backgroundColor: theme.labels.quote },
    recommend: { fontColor: theme.shades.white, backgroundColor: theme.colors.main4 },
};

export const LabelBox = ({ label, type }: ILabelBoxProps) => {
    const labelType = labelClusterType[type];

    const labelBgColor = labelType ? labelType.backgroundColor : theme.labels.quote;
    const labelColor = labelType ? labelType.fontColor : theme.shades.white;
    const labelIcon = labelType ? labelType.icon : null;

    return (
        <StyledLabelContainer
            data-testid={`label-box`}
            backgroundColor={alpha(labelBgColor, labelIcon ? 0.7 : 1)}
        >
            <StyledLabelText color={labelColor}>
                {labelIcon ? (
                    <SvgIcon
                        style={{
                            backgroundColor: labelBgColor,
                            // fontSize: 15,
                            verticalAlign: 'middle',
                        }}
                    >
                        {labelType.icon}
                    </SvgIcon>
                ) : null}
                {label}
            </StyledLabelText>
        </StyledLabelContainer>
    );
};
